/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from "react";
import { AgGridReact } from 'ag-grid-react';
import "../../CSS/general.css";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Axios from "axios";
import { setItem, getItem } from "../IndexedDBUtils";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import moment from "moment";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import decryptParameter from "../../Helpers/DeCryptParameter";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavBar } from "../NavBar";
import { trim } from "lodash";
import AuthenticationContext from "../../Store/Authentication-Context";
import LoaderGif from "../../images/365 loading.gif";
const Reseller = () => {
    
    const { setAuthContext, setBranding } = useContext(AuthenticationContext);
    const authContext = useContext(AuthenticationContext);
    const [rowData, setRowData] = useState();
    ////const [managedOrgId, setManagedOrgId] = useState();
    ////const [managedOrgName, setManagedOrgName] = useState();
    const [rowDataSelected, setRowDataSelected] = useState();
    const [tableRefresh, setTableRefresh] = useState(false);
    const [priceModelsData, setPriceModelsData] = useState();
    const [orgStatuses, setOrgStatuses] = useState();
    const [modalBody, setModalBody] = useState('');
    const [loaded, setloaded] = useState(false);
    const [operationFilter, setOperationFilter] = useState(null);
    const [tenantSummaryURL, setTenantSummaryURL] = useState("");
    const [showTenantSummary, setShowTenantSummary] = useState(false);
    const [validation, setValidation] = useState({
        isOrgValid: true,
        orgErrorMessage: "",
       
        
    });
    useEffect(() => {
        setBranding(sessionStorage.getItem("orgId"), sessionStorage.getItem("orgName"));
     
        if (decryptParameter(sessionStorage.getItem("ResellerID")) === "1") {

            window.location.href = "/masterAdmin=" + sessionStorage.getItem("orgId") + "&orgName=" + sessionStorage.getItem("orgName");
        }

        setloaded(true);

    }, []);
    const [show, setShow] = useState(false);

    const showToast = (type, message) => {
        if (type === "success") {
            toast.success(message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
        else if (type === "error") {
            toast.error('! ' + message, {
                position: 'top-right',
                hideProgressBar: false,

                pauseOnHover: true,
                draggable: false,
                closeButton: true, // Include a close button
                style: {
                    color: 'red' // Set the color to red
                },
                autoClose: false // Prevent automatic closing
            });
        }
        else if (type === "warning") {
            toast.warning(message, {
                position: 'top-right',
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: false,
                closeButton: true, 
                style: {
                    color: '#856404'
                },
                autoClose: false
            });
        };
    }
    const dateFormatter = (params) => {

        if (params.value)
            return moment(params.value, 'DD/MM/YYYY').format("DD-MM-YYYY").toString();
        else
            return params.value;
    };

    const renderTooltip = (props) => (

        <Tooltip id={`tooltip-${props.id}`} {...props}>
            {props.text}
        </Tooltip>

    );
    const orgColumnDefs= [
        {
            headerName: 'Options', minWidth: 150, flex: 1,
            cellRenderer: (params) => {
                return (
                    <div className="justify-content-between d-flex align-items-center">
                      
                        <button className='a-icon' onClick={() => handleShow(params)}>
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Edit Customer" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                </svg>
                            </OverlayTrigger>
                        </button>
                        <button
                            onClick={() => suspendOrg(params)}
                            className={params.data.isReseller ? 'disabled-link a-icon' : 'a-icon'}
                            style={params.data.isReseller ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                        >
                            <OverlayTrigger
                                key="sort-1"
                                placement="top"
                                delay={{ show: 50, hide: 50 }}
                                overlay={(props) =>
                                    renderTooltip({ ...props, id: "sort-1", text: "Disable Access" })
                                }
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pause-circle"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                                    />
                                    <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                                </svg>
                            </OverlayTrigger>
                        </button>
                       
                        <button onClick={() => activateOrg(params)}
                            className={params.data.isReseller ? 'disabled-link a-icon' : 'a-icon'}
                            style={params.data.isReseller ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                        >
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Enable Access" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-play-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                       

                        <button className='a-icon' onClick={() => handleTenantSummary(params)}>
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "View Tenant Summary" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                </svg>
                            </OverlayTrigger>

                        </button>
                            <button onClick={() => manageOrg(params)}
                            className={(((params.data.managed === true && params.data.disableAccess === false) || params.data.isReseller) &&
                                !(params.data.tennantDomain.toLowerCase().includes(sessionStorage.getItem('DomainId').toLowerCase()) && sessionStorage.getItem('ResellerRole') === 'HideManage')) ? 'a-icon' : 'disabled-link a-icon'}
                            style={(((params.data.managed === true && params.data.disableAccess === false) || params.data.isReseller) &&
                                !(params.data.tennantDomain.toLowerCase().includes(sessionStorage.getItem('DomainId').toLowerCase()) && sessionStorage.getItem('ResellerRole') === 'HideManage')) ? {} : { pointerEvents: 'none', opacity: 0.5 }}
                            >
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Manage Organisation" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">
                                        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
                                        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                    </div>
                );
            },
        },
       
        {
            headerName: 'Organisation Name', field: 'orgName', sortable: true, filter: true, minWidth: 300, flex: 1, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
},// Operation finance


        {
            headerName: 'Status', field: 'currentStatus', sortable: true, filter: true, minWidth: 200, flex: 1, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
},// Operation finance Admin


        {
            headerName: 'Date Created', field: 'creationDate', sortable: true, filter: true, minWidth: 150, flex: 1, valueFormatter: dateFormatter, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }
                
                return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            },
        },//operation

        {
            headerName: 'Trial Date', field: 'trialUntil', sortable: true, filter: true, minWidth: 170, flex: 1, valueFormatter: dateFormatter, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }
                
                return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            },
        },// Operation finance
        {
            headerName: 'Package', field: 'priceModel', sortable: true, filter: true, resizable: true, minWidth: 200, flex: 1, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
},//Finance
        { headerName: 'Users', field: 'userCount', sortable: true, filter: true, minWidth: 95, flex: 1, resizable: true },//Finance 
        { headerName: 'GB', field: 'spaceUsedGB', sortable: true, filter: true, minWidth: 95, flex: 1, resizable: true },//Finance 

        {
            headerName: '365 Last Run', field: 'lastBackup', sortable: true, filter: true, minWidth: 170, flex: 1, valueFormatter: dateFormatter, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }
                
                return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }, cellRenderer: function (params) {

                // Check if JobStatus exists and its value
                if ((params.data.lastBackup)) {
                    return dateFormatter(params);
                }
                else {
                    return '<div class="pt-1"><svg width="25" height="25" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class=" m-1 ms-3"> < circle cx = "15" cy = "50" r = "10" fill = "curren<animate attributeName="cy" values="50;5;50" dur="1s" repeatCount="indefinite" begin="0s"></animate></circle ><circle cx="50" cy="50" r="10" fill="currentColor"><animate attributeName="cy" values="50;5;50" dur="1s" repeatCount="indefinite" begin="0.2s"></animate></circle><circle cx="85" cy="50" r="10" fill="currentColor"><animate attributeName="cy" values="50;5;50" dur="1s" repeatCount="indefinite" begin="0.4s"></animate></circle></svg ></div>';
                }
            }
        },//operation
        {
            headerName: '365 Job Status',
            field: 'warningCount',
            sortable: true,
            minWidth: 150, flex: 1,
            filter: true,
            cellRenderer: function (params) {
                const { lastBackupStatus, warningSplitUpMsg, warningCount } = params.data || {};

                const badgeStyle = (bg) => ({
                    padding: "0 9px",
                    color: "white",
                    background: bg,
                    fontSize: "14px",
                    borderRadius: "5px",
                });

                if (lastBackupStatus) {
                    switch (lastBackupStatus) {
                        case "Red":
                            return (
                                <div className="pt-1" title={warningSplitUpMsg}>
                                    <span style={badgeStyle("red")} className="m-1 ms-3">
                                        {warningCount}
                                    </span>
                                </div>
                            );

                        case "Black":
                            return (
                                <div className="pt-1" title={warningSplitUpMsg}>
                                    <span style={badgeStyle("black")} className="m-1 ms-3">
                                        {warningCount}
                                    </span>
                                </div>
                            );

                        case "Green":
                            return (
                                <div className="pt-1">
                                    <span style={badgeStyle("green")} className="m-1 ms-3">
                                        {warningCount}
                                    </span>
                                </div>
                            );

                        case "Amber":
                            return (
                                <div className="pt-1" title={warningSplitUpMsg}>
                                    <span style={badgeStyle("orange")} className="m-1 ms-3">
                                        {warningCount}
                                    </span>
                                </div>
                            );

                        case "Running":
                            return (
                                <div className="pt-1">
                                    <img
                                        style={{ height: "4rem", marginLeft: "-1rem" }}
                                        src="data:image/gif;base64,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"
                                        alt="Running Vector GIF"
                                    />
                                </div>
                            );

                        default:
                            return lastBackupStatus;
                    }
                }

                // Fallback loader (SVG)
                return (
                    <div className="pt-1">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 100 100"
                            xmlns="http://www.w3.org/2000/svg"
                            className="m-1 ms-3"
                            fill="currentColor"
                        >
                            <circle cx="15" cy="50" r="10">
                                <animate
                                    attributeName="cy"
                                    values="50;5;50"
                                    dur="1s"
                                    repeatCount="indefinite"
                                    begin="0s"
                                />
                            </circle>

                            <circle cx="50" cy="50" r="10">
                                <animate
                                    attributeName="cy"
                                    values="50;5;50"
                                    dur="1s"
                                    repeatCount="indefinite"
                                    begin="0.2s"
                                />
                            </circle>

                            <circle cx="85" cy="50" r="10">
                                <animate
                                    attributeName="cy"
                                    values="50;5;50"
                                    dur="1s"
                                    repeatCount="indefinite"
                                    begin="0.4s"
                                />
                            </circle>
                        </svg>
                    </div>
                );
            },
            comparator: function (valueA, valueB, nodeA, nodeB) {
                const order = ['Black', 'Green', 'Running', 'Amber', 'Red'];

                // Get the index of each value in the order array
                const indexA = order.indexOf(nodeA.data.lastBackupStatus);
                const indexB = order.indexOf(nodeB.data.lastBackupStatus);

                // Compare the indexes
                if (indexA === indexB) {
                    return 0;
                } else if (indexA === -1) {
                    // If valueA is not found in the order array, place it at the end
                    return 1;
                } else if (indexB === -1) {
                    // If valueB is not found in the order array, place it at the end
                    return -1;
                } else {
                    // Compare indexes directly
                    return indexA - indexB;
                }
            }
        },
        {
            headerName: 'Managed',
            field: 'managed', sortable: true,
            cellRenderer: (params) => {

                return (
                    <input
                        type="checkbox"
                        checked={params.data.managed}

                        disabled={true}
                    />
                );
            }, minWidth: 100, flex: 1,
        }


    ];

    const orgChange = (params) => {

        setRowDataSelected({ ...rowDataSelected, orgName: params.target.value });
        if (params.target.value !== "" && params.target.value.length < 200) {


            setValidation({
                ...validation,
                isOrgValid: true,
                orgErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isOrgValid: false,
                    orgErrorMessage: "Organization Name should not be Empty"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isOrgValid: false,
                    orgErrorMessage: "Organization Name Should not be more than 200 character "
                });
            }
        }
    }

  


    const priceModelChange = (params) => {
        if (params.target.value !== "--Select--") {
            setRowDataSelected({
                ...rowDataSelected,


                priceModel: params.target.value

            });
        }
    }

    async function updOrgData(params) {


            var tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },

            };

            if (validation.isOrgValid) {
                setOperationFilter(gridApiRef.current.getFilterModel());
                let selpriceModelID = priceModelsData.find(model => model.name === rowDataSelected.priceModel);
                let selCurrentStatus = orgStatuses.find(model => model.status === rowDataSelected.currentStatus);
                let currentsts = "";
                if (!selpriceModelID) {
                    ////showToast("warning", "Selected package is not applicable to your account.")
                    ////return;
                    selpriceModelID = {
                        id: rowDataSelected.priceModelID, name: rowDataSelected.priceModel
                    }
                }
                if (selCurrentStatus) { currentsts = rowDataSelected.currentStatus }
                else { currentsts = orgStatuses[0].status }
                let payload = {

                    orgName: rowDataSelected.orgName,
                    orgId: rowDataSelected.orgId,
                    currentStatus: currentsts,
                    priceModelID: selpriceModelID.id,
                    priceModelIDSpecified: true,
                };

                setTableRefresh(true);

                await Axios.post(API_ROUTE + Routes.UPDATE_ORG, payload, config)
                    .then((response) => {
                        if (response.data) {
                            showToast("error", response.data);
                        }

                        return response;
                    })
                    .catch((reason) => {
                        if (reason) {
                            showToast("error", reason);
                        }
                        else if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";                        }
                    });
                setShow(false);
                getResellerOrgs(rowDataSelected.orgId, true);
            }
            else {
                if (rowDataSelected.orgName === "") {
                    showToast("error", "Organization Name should not be empty")
                }
                else {
                    showToast("error", "Organization Name should not be more the 200 character")
                }
            }
        
        }



    const handleShow = (params) => {
        getResellerOrgs(null, false, false);

        setRowDataSelected(params.data);

        setValidation({
            ...validation,
            isOrgValid: true,
            orgErrorMessage: "",
           
            
        });

        // Parse the contractStartDate string using Moment.js
        //const contractStartDate = moment(params.data.contractStart, 'MM/DD/YYYY hh:mm:ss A').toDate();

        // Update the state
        /* setRowDataSelected({
             ...rowDataSelected,
              contractDate: contractStartDate
         });*/


        setShow(true)
    };

    const gridApiRef = useRef(null);

    const onGridReady = (params) => {
        // Get a reference to the grid API
        gridApiRef.current = params.api;

        gridApiRef.current.setFilterModel(operationFilter);
        gridApiRef.current.refreshClientSideRowModel('filter');
    };
    async function suspendOrg(params) {
        try {
            const confirmSuspension = window.confirm("Are you sure you want to suspend this Organisation?");

            if (confirmSuspension) {
                setOperationFilter(gridApiRef.current.getFilterModel());
                var tokenString = await setAuthContext("", new Date());
                setTableRefresh(true);
           
                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                const inputData = {
                    resellerID: sessionStorage.getItem("ResellerID") ? decryptParameter(sessionStorage.getItem("ResellerID")) : "",
                    status: "SUSPENDED",
                    orgId: params.data.orgId,
                    OrgName: params.data.orgName,
                    // Token: tokenString,
                    username: sessionStorage.getItem("Username") ? decryptParameter(sessionStorage.getItem("Username")) : "",

                };

                await Axios.post(API_ROUTE + Routes.CHANGE_ORG_STATUS, inputData, config)
                    .then((response) => {
                        if (response.data) {
                            showToast("error", response.data);
                        }

                    }).catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";                        }                       
                    });
                getResellerOrgs(params.data.orgId, true);

            }
            
        }
        catch (error) { }
       

    };
    async function activateOrg(params) {
        try {
            const confirmActivate = window.confirm("Are you sure you want to activate this Orgainisation?");

            if (confirmActivate) {
                setOperationFilter(gridApiRef.current.getFilterModel());
                setTableRefresh(true);
              
                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                const inputData = {
                    resellerID: sessionStorage.getItem("ResellerID") ? decryptParameter((sessionStorage.getItem("ResellerID"))) : "",
                    status: "LIVE",
                    orgId: params.data.orgId,
                    OrgName: params.data.orgName,
                    // Token: tokenString,
                    username: sessionStorage.getItem("Username") ? decryptParameter((sessionStorage.getItem("Username"))) : "",

                };

                await Axios.post(API_ROUTE + Routes.CHANGE_ORG_STATUS, inputData, config)
                    .then((response) => {
                        if (response.data) {
                            showToast("error", response.data);
                        }

                    }).catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";                        }
                    });
                getResellerOrgs(params.data.orgId, true);

            }
           
        }
        catch (error) { }


    };
    async function writeLog(orgName, orgId) {



        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        const inputData = {
            EventType: "INFO",
            PublicView:true,
            EventDetail: "Managed Org - " + orgName,
            EventSource: "RESSELLER",
            EventUser: sessionStorage.getItem("UserName"),
            OrgID: orgId,

        };

        await Axios.post(API_ROUTE + Routes.WRITE_LOG, inputData, config)
            .then((response) => {
                

            });

    }

    async function manageOrg(params) {
        try {
            const manageorg = window.confirm("Only manage if you have permision to do so. Ask the Organisation first.");

            if (manageorg) {
                sessionStorage.setItem('ManageOrgId', params.data.orgId);
                sessionStorage.setItem('ManageOrgName', params.data.orgName);
                sessionStorage.setItem('ManageTenantDomain', params.data.tennantDomain);
                sessionStorage.setItem('GuardianOnlyEnabled-' + params.data.orgId, !(params.data.m365Enabled.toString() === "true"));
                await  writeLog(params.data.orgName, params.data.orgId);
                ////setManagedOrgId(sessionStorage.getItem('ManageOrgId'));
                ////setManagedOrgName(sessionStorage.getItem('ManageOrgName'));
                window.location.href = "/main?orgId=" + params.data.orgId + "&orgName=" + params.data.orgName;
            }

        }
        catch (error) { }


    };
    const fetchStatusData = async () => {
        try {
            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const inputData = {
                ServerPath: sessionStorage.getItem('ServerPath') ? decryptParameter((sessionStorage.getItem('ServerPath'))) : "",
                ResellerID: sessionStorage.getItem("ResellerID") ? decryptParameter((sessionStorage.getItem("ResellerID"))) : "",
                Orderby: "ResellerName",

                Username: sessionStorage.getItem("Username") ? decryptParameter(sessionStorage.getItem("Username")) : "",



            };
            const updatedData = await getItem('ResellerOrganisation');
            const response = await Axios.post(API_ROUTE + Routes.GET_MASTERADMIN_RESELLER_ORG_STATUS, inputData, config);
            if (response && response.data ) {
                const responsedata = response.data.resellers;
                setRowData(prevRowData => {
                    const updatedRowData = JSON.parse(updatedData);
                    responsedata.forEach((reseller) => {
                        const matchingRecordIndex = updatedRowData.findIndex(
                            (prevReseller) => prevReseller.orgId === reseller.orgId
                        );
                        if (matchingRecordIndex !== -1) {
                            updatedRowData[matchingRecordIndex].lastBackup = reseller.lastBackup;
                            updatedRowData[matchingRecordIndex].lastBackupStatus = reseller.lastBackupStatus;
                            updatedRowData[matchingRecordIndex].warningCount = reseller.warningCount;
                            updatedRowData[matchingRecordIndex].warningSplitUpMsg = reseller.warningSplitUpMsg;
                        }
                    });
                    setItem('ResellerOrganisation', JSON.stringify(updatedRowData));

                    return updatedRowData;
                });


            }
        } catch (error) {
            console.error("Error fetching status data:", error);
              if (error?.response?.status === 440) {
                  window.location.href = "/TimeoutErrorHandler";              }
        }
    };
    async function getResellerOrgs(fetchOrgId, fromCache, isRefresh) {
        // Flag to track component mount state
        if (decryptParameter(sessionStorage.getItem("ResellerID")) !== "1") {
            try {

                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                const inputData = {
                    ServerPath: sessionStorage.getItem("ServerPath") ? decryptParameter((sessionStorage.getItem("ServerPath"))) : "",
                    ResellerID: sessionStorage.getItem("ResellerID") ? decryptParameter((sessionStorage.getItem("ResellerID"))) : "",
                    Orderby: "ResellerName",
                    // Token: tokenString,
                    Username: sessionStorage.getItem("Username") ? decryptParameter(sessionStorage.getItem("Username")) : "",
                    OrgId: fetchOrgId,
                };


            
                if (sessionStorage.getItem('lastUpdateTime')) {


                const lastUpdateTime = parseInt(sessionStorage.getItem('lastUpdateTime'), 10);
                const currentTime = new Date().getTime();
                if ((currentTime - lastUpdateTime) >= (10 * 60 * 1000)) {

                    //If time is more than 10mins clear the cachevalues;
                    isRefresh = true;
                }

            }

                if (fromCache) {

                    await Axios.post(API_ROUTE + Routes.GET_MASTERADMIN_RESELLER_ORG_CACHE, inputData, config)
                        .then((response) => {

                            let responsedata = response.data;

                            setRowData(prevRowData => {
                                const updatedRowData = [...prevRowData];
                                responsedata.forEach((reseller) => {
                                    const matchingRecordIndex = updatedRowData.findIndex(
                                        (prevReseller) => prevReseller.orgId === reseller.orgId
                                    );
                                    if (matchingRecordIndex !== -1) {
                                        reseller.lastBackup = updatedRowData[matchingRecordIndex].lastBackup;
                                        reseller.lastBackupStatus = updatedRowData[matchingRecordIndex].lastBackupStatus;
                                        reseller.warningCount = updatedRowData[matchingRecordIndex].warningCount;
                                        reseller.warningSplitUpMsg = updatedRowData[matchingRecordIndex].warningSplitUpMsg;
                                        updatedRowData[matchingRecordIndex] = reseller;
                                    }
                                });
                                setItem('ResellerOrganisation', JSON.stringify(updatedRowData))
                                return updatedRowData;
                            });


                        })
                        .catch((reason) => {

                            if (reason?.response?.status === 403) {
                                window.location.href = "/Unauthorized";
                            }
                            else if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";                            }
                        });
                }
                else {

                    await Axios.post(API_ROUTE + Routes.GET_MASTERADMIN_RESELLER_ORG, inputData, config)
                        .then((response) => {
                            console.log(response);
                            if (response && response.data) {
                                let responsedata = response.data;
                                let data = (responsedata.resellers) ? responsedata.resellers : null;
                                setRowData(data);
                                setItem('ResellerOrganisation', JSON.stringify(data))
                                setRowData(data);
                                setOrgStatuses(responsedata.orgStatuses);
                                setItem('OrgStatuses', JSON.stringify(responsedata.orgStatuses));
                                setPriceModelsData(responsedata.priceModels)
                                setItem('PriceModels', JSON.stringify(responsedata.priceModels));
                                const currentDateTime = new Date().getTime(); // Get current datetime in milliseconds
                                sessionStorage.setItem('lastUpdateTime', currentDateTime);
                                fetchStatusData();
                            }
                        })
                        .catch((reason) => {
                            if (reason?.response?.status === 403) {
                                window.location.href = "/Unauthorized";
                            }
                            else if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }

            }
            catch (error) {
                console.log(error)
            }
            setTableRefresh(false);
            
        }
    }
    async function handleTenantSummary(params) {
        var orgId = params.data.orgId
        var orgName = params.data.orgName
        var url = '/TenantSummary?orgId=' + orgId + '&orgName=' + orgName + '&masterAdmin=true'
        setTenantSummaryURL(url)
        setShowTenantSummary(true)
    }
    useEffect(() => {
        getResellerOrgs(null, false, false);

    }, []);

    const handleStatusChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,


            currentStatus: params.target.value

        });

    };
   


    useEffect(() => {

        if (rowDataSelected) {
           
                setModalBody(
                    <>
                        <Row>
                            <Col>
                                <Form>
                                    
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Organisation Name</Form.Label>
                                        <Form.Control type="text" isInvalid={!validation.isOrgValid} placeholder="Organisation Name" value={rowDataSelected.orgName} onChange={orgChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {validation.orgErrorMessage}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.Selectprice"  >
                                        <Form.Label>Price Model</Form.Label>
                                        <Form.Select value={rowDataSelected.priceModel} disabled={rowDataSelected.currentStatus !== "TRIAL"}
                                            className={rowDataSelected.currentStatus !== "TRIAL" ? "text-muted bg-light" : ""}
                                            onChange={priceModelChange}>
                                            {!priceModelsData.find(model => model.name === rowDataSelected.priceModel) && 
                                                <option key={rowDataSelected.priceModelID} value={rowDataSelected.priceModel}>
                                                    {rowDataSelected.priceModel}
                                                </option>
                                            }

                                            {
                                                priceModelsData
                                                    ?.filter(sts => sts.weightage >= rowDataSelected?.weightage)
                                                    ?.map((sts) => (
                                                        <option key={sts.id} value={sts.name}>
                                                            {sts.name}
                                                        </option>
                                                    ))
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Stage</Form.Label>

                                        <Form.Select value={trim(rowDataSelected.currentStatus)} 
                                            onChange={handleStatusChange}
                                        >

                                            {
                                                orgStatuses && Array.isArray(orgStatuses) && orgStatuses.map((sts) => (
                                                    <option key={sts.id} value={sts.status}>
                                                        {sts.status}
                                                    </option>
                                                ))
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>

                    </>)
            
 
        }


    }, [rowDataSelected]);

    const handleClose = () => setShow(false);
    const handleTenantSummaryClose = () => setShowTenantSummary(false);
    const toInitCase = (str) => {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });


    };
    return (
        <>
            {loaded &&
            <NavBar page="reseller" authContext={authContext} /> }
            <div className="card-header reseller-card p-1">
                <span className="SectionTitle" style={{display:"contents"} }>PARTNER CUSTOMER LIST &nbsp; &nbsp; &nbsp;
                    <a id="ContentPlaceHolder1_btnAddRep" style={{ color: "#007bff" }} href={"/SignUp?resellerId=" + decryptParameter(sessionStorage.getItem("ResellerID"))}><Button variant="primary" className="me-2"> <i className="fas fa-plus"></i> Add Tenant</Button> </a>
                    {/*<a id="ContentPlaceHolder1_btnAddRep1" style={{ color: "#007bff", textDecoration: "none" }} href={"/GuardianSignUp?resellerId=" + decryptParameter(sessionStorage.getItem("ResellerID"))}><Button variant="primary" className="me-2"> <i className="fa fa-plus" style={{ color: 'white' }}></i> Add Guardian Tenant</Button> </a>*/}
                    <button id="ContentPlaceHolder1_btnDownload" style={{ color: "#007bff", cursor: 'pointer', float: 'inline-end' }} className="me-2 a-icon">
                        <Button title="Download" onClick={(e) => {
                            gridApiRef.current.exportDataAsCsv();
                            //gridApiRef.current.sizeColumnsToFit();
                        }
                        } variant="primary">  <svg
                                className="svg-inline--fa fa-download fa-w-18 fa-lg"
                                style={{ color: 'white', fill: 'transparent', fontSize: '16px' }}
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="far"
                                data-icon="download"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M528 288h-92.1l46.1-46.1c30.1-30.1 8.8-81.9-33.9-81.9h-64V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v112h-64c-42.6 0-64.2 51.7-33.9 81.9l46.1 46.1H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80h112V48h96v160h112L288 368 128 208zm400 256H48V336h140.1l65.9 65.9c18.8 18.8 49.1 18.7 67.9 0l65.9-65.9H528v128zm-88-64c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z"
                                />
                            </svg></Button>

                    </button>
                    <button id="ContentPlaceHolder1_btnClear" style={{ color: "#007bff", cursor: 'pointer', float: 'inline-end' }} className="me-1 a-icon">
                        <Button title="Clear Filter" onClick={(e) => {
                            if (gridApiRef.current) {
                                gridApiRef.current.setFilterModel(null);
                            }
                        }
                        } variant="primary"> <svg xmlns="http://www.w3.org/2000/svg" height="20" fill="white" stroke="white" viewBox="0 0 32 32" width="20" style={{ cursor: 'pointer' }}>
                                <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                            </svg></Button>

                    </button>
                    <button id="ContentPlaceHolder1_btnRefresh" title="Refresh" className="me-1 btn btn-primary" style={{ color: "#007bff", float: 'inline-end' }} variant="primary" onClick={(e) => {

                        setTableRefresh(true);
                        getResellerOrgs(null, false, true);
                    }
                    }>
                        <svg style={{ marginBottom: '.1rem' }} className="me-1 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                            </path>
                        </svg></button>

                </span>
            </div>
           
           
            <div className="ag-theme-alpine p-1 mt-2" style={{ border:'1px solid', maxHeight: '77vh', borderCollapse: "collapse", height: '76vh' }}>
                    {tableRefresh ?
                    <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                        <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                    </div> :
                        <AgGridReact
                            rowData={rowData}
                            enableCellTextSelection="true"
                            columnDefs={orgColumnDefs}
                            animateRows={true}

                            onGridReady={onGridReady}  // Pass the onGridReady callback here
                        overlayLoadingTemplate={
                            `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                            overlayNoRowsTemplate={
                                '<span className="ag-overlay-loading-center">No records to show</span>'
                            }

                        >
                        </AgGridReact>
                    }

                </div>

               

            <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{toInitCase("Edit Customer")} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalBody}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => updOrgData()} >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showTenantSummary} onHide={handleTenantSummaryClose} className="tenant-summary-popup">
                <Modal.Header closeButton>
                    <Modal.Title>Tenant Summary</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <iframe src={tenantSummaryURL} sandbox="allow-scripts allow-same-origin"
                            style={{ height: "70vh", width: '100%', minWidth: "-webkit-fill-available" }} title="Tenant Summary"></iframe>
                    </div>
                </Modal.Body>
            </Modal>
            {//<ToastContainer limit={4} style={{ fontSize: "small" }} />
                }
        </>
    );
}

export default Reseller 